import hosts from '../hosts';

export default function(options) {
  const headers = Object.assign({
    'content-type': 'application/json'
  }, options.headers);

  return {
    url: hosts.h5 + options.url,
    method: options.method,
    headers,
    data: Object.assign({
      // iOS微信会缓存请求响应，包括POST，所以在每个请求上添加一个时间戳
      t: new Date().getTime()
    }, options.data)
  };
}



// WEBPACK FOOTER //
// ./src/request/transformers/h5.js